import {SymbolRecognitionProcessInfoDto} from "./restModels";

export class SymbolRecognitionProcessInfo {
	constructor(public readonly id: string,) {
	}

	public static fromJson(json: SymbolRecognitionProcessInfoDto): SymbolRecognitionProcessInfo {
		return new SymbolRecognitionProcessInfo(json.data.id);
	}
}